import { Section } from '../components/Section';
import {
  Container,
  Box,
  TabList,
  Tabs,
  Tab,
  Flex,
  Icon,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react';
import { QuoteCard } from '../components';
import { useTranslation } from 'react-i18next';
import { IoIosArrowDropleft } from 'react-icons/io';
import type { IOrder } from '@/types';
import { ROUTE_PATHS } from '@/constants';
import { NavLink } from 'react-router-dom';
import { useFetchDocs } from '@/hooks';
import { SectionLoader } from '@/components/shared';

export const UserQuotes = (): JSX.Element => {
  const { t } = useTranslation();

  const { docs, isLoading } = useFetchDocs();

  const quotes = docs?.filter((doc) => doc.type === 'quote');

  let activeQuotes: IOrder[] = [];
  let expiredQuotes: IOrder[] = [];

  if (quotes && quotes.length > 0) {
    activeQuotes = quotes.filter(
      (quote): boolean =>
        new Date(quote.quoteExpiryDate).getTime() > Date.now() || quote.status === 'QUOTE_REQUESTED'
    );

    expiredQuotes = quotes.filter(
      (quote): boolean =>
        new Date(quote.quoteExpiryDate).getTime() < Date.now() && quote.status !== 'QUOTE_REQUESTED'
    );
  }

  return (
    <Box bg="brand.sand" py={8} w="full">
      <Container maxW="8xl" pt={{ base: 8, lg: 2 }} px={{ base: 4, md: 8 }}>
        <NavLink color="brand.red.light" to={ROUTE_PATHS.userDashboard}>
          <Icon
            as={IoIosArrowDropleft}
            color="brand.red.light"
            h={12}
            marginBottom={6}
            mx={0}
            w={12}
          />
        </NavLink>
        <Section id="quotes" title={t('ACCOUNT.QUOTES.TITLE')}>
          <Tabs flexGrow={1} isLazy pt={6} variant="mbe">
            <TabList gap={{ base: 4, md: 2 }}>
              <Tab>{t('ACCOUNT.QUOTES.ACTIVE')}</Tab>
              <Tab>{t('ACCOUNT.QUOTES.EXPIRED')}</Tab>
            </TabList>
            {isLoading ? (
              <SectionLoader />
            ) : (
              <TabPanels>
                <TabPanel pt={10} px={0}>
                  <Flex flexDirection="column" gap={10}>
                    {activeQuotes.map((quote) => (
                      <QuoteCard key={quote.id} quote={quote} />
                    ))}
                  </Flex>
                </TabPanel>
                <TabPanel pt={10} px={0}>
                  <Flex flexDirection="column" gap={10}>
                    {expiredQuotes.map((quote) => (
                      <QuoteCard isExpired={true} key={quote.id} quote={quote} />
                    ))}
                  </Flex>
                </TabPanel>
              </TabPanels>
            )}
          </Tabs>
        </Section>
      </Container>
    </Box>
  );
};
